import CustomBreadcrumbs from "../../components/minimal/custom-breadcrumbs";
import { fDate } from "../../utils/minimal/formatTime";
import { Stack } from "@mui/material";
import Label from "../../components/minimal/label";
import { useLocales } from "../../locales";
import useCopyToClipboard from "../../hooks/minimal/useCopyToClipboard";
import { useSnackbar } from "notistack";
import { useEventLink } from "../../hooks/useEventLink";
import Iconify from "../../components/minimal/iconify";

export const EventBreadcrumbs = ({ heading, event, action, sx = {} }) => {

    const { translate } = useLocales()
    const { enqueueSnackbar } = useSnackbar();
    const { copy } = useCopyToClipboard();
    const eventUrl = useEventLink()
    // this domain + /scanner/ + event.id
    const scannerUrl = `${window.location.origin}/scanner/${event._id}`

    const handleCopy = (text) => {
        enqueueSnackbar(translate('dashboard.events.copied'));
        copy(text);
    };

    return (
        <Stack>
            <CustomBreadcrumbs
                action={action}
                sx={sx}
                heading={heading}
                headAction={
                    <Stack direction="row" gap="10px" alignItems="center">
                        <Stack direction="row" gap="5px">
                            <Label onClick={() => handleCopy(eventUrl)} sx={{ py: 1, mt: 1, cursor: "pointer" }} color="info" variant="soft">
                                {translate('dashboard.events.copy_event_link')}
                            </Label>
                            <Label
                                onClick={() => window.open(eventUrl, '_blank')}
                                sx={{ py: 1, mt: 1, cursor: "pointer", minWidth: 'auto', px: 1 }}
                                color="info"
                                variant="soft"
                                title={translate('dashboard.events.open_in_new_tab')}
                            >
                                <Iconify icon="mdi:open-in-new" width={18} />
                            </Label>
                        </Stack>
                        <Stack direction="row" gap="5px">
                            <Label onClick={() => handleCopy(scannerUrl)} sx={{ py: 1, mt: 1, cursor: "pointer" }} color="warning" variant="soft">
                                {translate('dashboard.events.copy_scanner_link')}
                            </Label>
                            <Label
                                onClick={() => window.open(scannerUrl, '_blank')}
                                sx={{ py: 1, mt: 1, cursor: "pointer", minWidth: 'auto', px: 1 }}
                                color="warning"
                                variant="soft"
                                title={translate('dashboard.events.open_in_new_tab')}
                            >
                                <Iconify icon="mdi:open-in-new" width={18} />
                            </Label>
                        </Stack>
                    </Stack>
                }
                links={[
                    {
                        name: event.name,
                    },
                    {
                        name: fDate(event.start_date),
                    }
                ]}
            />
        </Stack>
    )
}